// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   get_vendor,
//   block_user
// } from "../../store/services/authentication";
// import {
//   FaRegEye,
//   FaTimes,
//   FaBuilding,
//   FaBan,
//   FaCheckCircle
// } from "react-icons/fa";
// import { asyncStatus } from "../../utils/contants/asyncStatus";

// const VendorManagment = () => {
//   const dispatch = useDispatch();
//   const { get_vendor_data, get_vendor_status, block_user_status } = useSelector(
//     (state) => state.userAuth
//   );
//   const [selectedVendor, setSelectedVendor] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     dispatch(get_vendor());
//     setIsModalOpen(false)
//   }, [dispatch, block_user_status]);

//   const handleView = (vendor) => {
//     setSelectedVendor(vendor);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedVendor(null);
//   };

//   const handleBlock = (vendorId, isCurrentlyBlocked) => {
//     const action = isCurrentlyBlocked ? "unblock" : "block";
//     if (window.confirm(`Are you sure you want to ${action} this vendor?`)) {
//       dispatch(block_user({
//         id: vendorId,
//         is_block: !isCurrentlyBlocked
//       }));
//     }
//   };

//   if (get_vendor_status === asyncStatus.LOADING) {
//     return <div className="text-center py-8 text-black">Loading vendors...</div>;
//   }

//   if (get_vendor_status === asyncStatus.ERROR) {
//     return <div className="text-center py-8 text-red-500">Error loading vendors</div>;
//   }

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <h1 className="text-2xl font-bold mb-6 text-gray-800">Vendor Management</h1>

//       {/* Vendor View Modal */}
//       {isModalOpen && selectedVendor && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold flex items-center gap-2 text-black">
//                 <FaBuilding className="inline-block" />
//                 {selectedVendor.business_name}
//                 {selectedVendor.is_block && (
//                   <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-sm">
//                     Blocked
//                   </span>
//                 )}
//               </h2>
//               <button
//                 onClick={closeModal}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <FaTimes className="h-6 w-6" />
//               </button>
//             </div>

//             {/* Add Block Reason Section */}
//             {selectedVendor.is_block && (
//               <div className="bg-red-50 p-4 rounded-lg mb-4">
//                 <div className="flex justify-between items-center">
//                   <h3 className="font-medium text-red-800">Block Details</h3>
//                   <button
//                     onClick={() => handleBlock(selectedVendor._id, true)}
//                     className="text-green-600 hover:text-green-800 flex items-center gap-1"
//                   >
//                     <FaCheckCircle className="inline-block" />
//                     <span>Unblock Vendor</span>
//                   </button>
//                 </div>
//                 {selectedVendor.block_reason && (
//                   <p className="mt-2 text-red-700">{selectedVendor.block_reason}</p>
//                 )}
//               </div>
//             )}

//              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-black">
//                {/* Left Column */}
//                <div className="space-y-4">
//                  <div className="flex items-center space-x-4">
//                    <img
//                      className="h-24 w-24 rounded-full"
//                      src={selectedVendor.avatar}
//                      alt="Vendor logo"
//                    />
//                    <div>
//                      <h3 className="text-lg font-semibold">
//                        {selectedVendor.first_name} {selectedVendor.last_name}
//                      </h3>
//                      <p className="text-gray-600">{selectedVendor.email}</p>
//                      <p className="text-sm text-gray-500">
//                        Vendor ID: {selectedVendor._id}
//                      </p>
//                    </div>
//                  </div>

//                  <div>
//                    <h4 className="font-medium mb-2 text-black">Business Details</h4>
//                    <dl className="space-y-2">
//                      <div>
//                        <dt className="text-sm text-gray-500">Business Plan</dt>
//                        <dd className="text-sm font-medium">
//                          {selectedVendor.plan}
//                        </dd>
//                      </div>
//                      <div>
//                        <dt className="text-sm text-gray-500">Stripe Customer ID</dt>
//                        <dd className="text-sm break-all">
//                          {selectedVendor.stripe_customer_id || 'N/A'}
//                        </dd>
//                      </div>
//                      <div>
//                        <dt className="text-sm text-gray-500">Subscription ID</dt>
//                        <dd className="text-sm break-all">
//                          {selectedVendor.subscription_id || 'Not subscribed'}
//                        </dd>
//                      </div>
//                    </dl>
//                  </div>
//                </div>

//                {/* Right Column */}
//                <div className="space-y-4">
//                  <div>
//                    <h4 className="font-medium mb-2">Account Status</h4>
//                    <div className="flex items-center gap-2">
//                      <span
//                        className={`px-2 py-1 rounded-full text-xs font-medium ${
//                          selectedVendor.verified
//                            ? 'bg-green-100 text-green-800'
//                            : 'bg-red-100 text-red-800'
//                        }`}
//                      >
//                        {selectedVendor.verified ? 'Verified' : 'Unverified'}
//                      </span>
//                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                        {selectedVendor.role}
//                      </span>
//                    </div>
//                  </div>
//                  <div>
//                    <h4 className="font-medium mb-2">Preferences</h4>
//                    <dl className="grid grid-cols-2 gap-2">
//                      <div>
//                        <dt className="text-sm text-gray-500">Interest In</dt>
//                        <dd className="text-sm">{selectedVendor.interest_in}</dd>
//                      </div>
//                      <div>
//                        <dt className="text-sm text-gray-500">Account Type</dt>
//                        <dd className="text-sm capitalize">{selectedVendor.plan}</dd>
//                      </div>
//                    </dl>
//                  </div>
//                </div>
//              </div>

//              {/* Dates Section */}
//              <div className="mt-4 pt-4 border-t border-gray-200">
//                <div className="flex justify-between text-sm text-gray-500">
//                  <div>
//                    Created: {new Date(selectedVendor.createdAt).toLocaleDateString()}
//                  </div>
//                  <div>
//                    Updated: {new Date(selectedVendor.updatedAt).toLocaleDateString()}
//                  </div>
//                </div>
//              </div>
//            </div>
//         </div>
//       )}

//       {/* Vendor Table */}
//       <div className="bg-white rounded-lg shadow overflow-hidden">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Business Name
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Contact
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Plan
//               </th>
//               {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Status
//               </th> */}
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {get_vendor_data?.users?.map((vendor) => (
//               <tr key={vendor._id} className={vendor.is_block ? "bg-red-50" : ""}>
//                 <td className="px-6 py-4 whitespace-nowrap">
//                   <div className="flex items-center">
//                     <div className="flex-shrink-0 h-10 w-10">
//                       <img
//                         className="h-10 w-10 rounded-full"
//                         src={vendor.avatar}
//                         alt={`${vendor.business_name} logo`}
//                       />
//                     </div>
//                     <div className="ml-4">
//                       <div className="text-sm font-medium text-gray-900">
//                         {vendor.business_name}
//                         {vendor.is_block && (
//                           <span className="ml-2 text-red-600 text-xs">
//                             (Blocked)
//                           </span>
//                         )}
//                       </div>
//                       <div className="text-sm text-gray-500">
//                         {vendor.first_name} {vendor.last_name}
//                       </div>
//                     </div>
//                   </div>
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   {vendor.email}
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
//                     {vendor.plan}
//                   </span>
//                 </td>
//                 {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
//                     vendor.verified ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
//                   }`}>
//                     {vendor.verified ? 'Verified' : 'Pending'}
//                   </span>
//                 </td> */}
//                 <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                   <button
//                     onClick={() => handleView(vendor)}
//                     className="text-indigo-600 hover:text-indigo-900 mr-4"
//                     aria-label="View vendor"
//                   >
//                     <FaRegEye className="inline-block" />
//                   </button>
//                   <button
//                     onClick={() => handleBlock(vendor._id, vendor.is_block)}
//                     className={`${
//                       vendor.is_block
//                         ? "text-green-600 hover:text-green-800"
//                         : "text-red-600 hover:text-red-800"
//                     }`}
//                     aria-label={vendor.is_block ? "Unblock vendor" : "Block vendor"}
//                   >
//                     <FaBan className="inline-block" />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {get_vendor_status === asyncStatus.SUCCEEDED && !get_vendor_data?.users?.length && (
//           <div className="text-center py-4 text-gray-500">
//             No vendors found
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default VendorManagment;

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   get_vendor,
//   block_user,
//   // add_user,
//   // update_user
// } from "../../store/services/authentication";
// import {
//   FaRegEye,
//   FaTimes,
//   FaBuilding,
//   FaBan,
//   FaCheckCircle,
//   FaPlus,
//   FaEdit
// } from "react-icons/fa";
// import { asyncStatus } from "../../utils/contants/asyncStatus";

// const VendorManagment = () => {
//   const dispatch = useDispatch();
//   const {
//     get_vendor_data,
//     get_vendor_status,
//     block_user_status,
//     add_user_status,
//     update_vendor_status
//   } = useSelector((state) => state.userAuth);

//   const [selectedVendor, setSelectedVendor] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [formData, setFormData] = useState({
//     business_name: '',
//     email: '',
//     plan: 'basic',
//     first_name: '',
//     last_name: ''
//   });

//   useEffect(() => {
//     dispatch(get_vendor());
//   }, [dispatch, block_user_status, add_user_status, update_vendor_status]);

//   const handleInputChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleAddVendor = () => {
//     setIsAddModalOpen(true);
//     setIsEditMode(false);
//     setFormData({
//       business_name: '',
//       email: '',
//       plan: 'basic',
//       first_name: '',
//       last_name: ''
//     });
//   };

//   const handleEdit = (vendor) => {
//     setSelectedVendor(vendor);
//     setIsEditMode(true);
//     setIsAddModalOpen(true);
//     setFormData({
//       business_name: vendor.business_name,
//       email: vendor.email,
//       plan: vendor.plan,
//       first_name: vendor.first_name,
//       last_name: vendor.last_name
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if(isEditMode) {
//       // dispatch(update_vendor({
//       //   id: selectedVendor._id,
//       //   ...formData
//       // }));
//     } else {
//       // dispatch(add_user(formData));
//     }
//     setIsAddModalOpen(false);
//   };

//   const handleView = (vendor) => {
//     setSelectedVendor(vendor);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedVendor(null);
//   };

//   const handleBlock = (vendorId, isCurrentlyBlocked) => {
//     const action = isCurrentlyBlocked ? "unblock" : "block";
//     if (window.confirm(`Are you sure you want to ${action} this vendor?`)) {
//       dispatch(block_user({
//         id: vendorId,
//         is_block: !isCurrentlyBlocked
//       }));
//     }
//   };

//   if (get_vendor_status === asyncStatus.LOADING) {
//     return <div className="text-center py-8 text-black">Loading vendors...</div>;
//   }

//   if (get_vendor_status === asyncStatus.ERROR) {
//     return <div className="text-center py-8 text-red-500">Error loading vendors</div>;
//   }

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <div className="flex justify-between items-center mb-6">
//         <h1 className="text-2xl font-bold text-gray-800">Vendor Management</h1>
//         <button
//           onClick={handleAddVendor}
//           className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
//         >
//           <FaPlus className="inline-block" />
//           Add Vendor
//         </button>
//       </div>

//       {/* Add/Edit Vendor Modal */}
//       {isAddModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold text-black">
//                 {isEditMode ? 'Edit Vendor' : 'Add New Vendor'}
//               </h2>
//               <button
//                 onClick={() => setIsAddModalOpen(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <FaTimes className="h-6 w-6" />
//               </button>
//             </div>

//             <form onSubmit={handleSubmit}>
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Business Name
//                   </label>
//                   <input
//                     type="text"
//                     name="business_name"
//                     value={formData.business_name}
//                     onChange={handleInputChange}
//                     className="w-full px-3 py-2 border rounded-lg"
//                     required
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Email
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     className="w-full px-3 py-2 border rounded-lg"
//                     required
//                   />
//                 </div>

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       First Name
//                     </label>
//                     <input
//                       type="text"
//                       name="first_name"
//                       value={formData.first_name}
//                       onChange={handleInputChange}
//                       className="w-full px-3 py-2 border rounded-lg"
//                       required
//                     />
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Last Name
//                     </label>
//                     <input
//                       type="text"
//                       name="last_name"
//                       value={formData.last_name}
//                       onChange={handleInputChange}
//                       className="w-full px-3 py-2 border rounded-lg"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Plan
//                   </label>
//                   <select
//                     name="plan"
//                     value={formData.plan}
//                     onChange={handleInputChange}
//                     className="w-full px-3 py-2 border rounded-lg"
//                   >
//                     <option value="basic">Basic</option>
//                     <option value="pro">Pro</option>
//                     <option value="enterprise">Enterprise</option>
//                   </select>
//                 </div>

//                 <div className="mt-6">
//                   <button
//                     type="submit"
//                     className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
//                   >
//                     {isEditMode ? 'Update Vendor' : 'Add Vendor'}
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Vendor View Modal */}
//       {isModalOpen && selectedVendor && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl font-semibold flex items-center gap-2 text-black">
//                 <FaBuilding className="inline-block" />
//                 {selectedVendor.business_name}
//                 {selectedVendor.is_block && (
//                   <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-sm">
//                     Blocked
//                   </span>
//                 )}
//               </h2>
//               <button
//                 onClick={closeModal}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <FaTimes className="h-6 w-6" />
//               </button>
//             </div>

//             {selectedVendor.is_block && (
//               <div className="bg-red-50 p-4 rounded-lg mb-4">
//                 <div className="flex justify-between items-center">
//                   <h3 className="font-medium text-red-800">Block Details</h3>
//                   <button
//                     onClick={() => handleBlock(selectedVendor._id, true)}
//                     className="text-green-600 hover:text-green-800 flex items-center gap-1"
//                   >
//                     <FaCheckCircle className="inline-block" />
//                     <span>Unblock Vendor</span>
//                   </button>
//                 </div>
//                 {selectedVendor.block_reason && (
//                   <p className="mt-2 text-red-700">{selectedVendor.block_reason}</p>
//                 )}
//               </div>
//             )}

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-black">
//               <div className="space-y-4">
//                 <div className="flex items-center space-x-4">
//                   <img
//                     className="h-24 w-24 rounded-full"
//                     src={selectedVendor.avatar}
//                     alt="Vendor logo"
//                   />
//                   <div>
//                     <h3 className="text-lg font-semibold">
//                       {selectedVendor.first_name} {selectedVendor.last_name}
//                     </h3>
//                     <p className="text-gray-600">{selectedVendor.email}</p>
//                     <p className="text-sm text-gray-500">
//                       Vendor ID: {selectedVendor._id}
//                     </p>
//                   </div>
//                 </div>

//                 <div>
//                   <h4 className="font-medium mb-2 text-black">Business Details</h4>
//                   <dl className="space-y-2">
//                     <div>
//                       <dt className="text-sm text-gray-500">Business Plan</dt>
//                       <dd className="text-sm font-medium">
//                         {selectedVendor.plan}
//                       </dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">Stripe Customer ID</dt>
//                       <dd className="text-sm break-all">
//                         {selectedVendor.stripe_customer_id || 'N/A'}
//                       </dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">Subscription ID</dt>
//                       <dd className="text-sm break-all">
//                         {selectedVendor.subscription_id || 'Not subscribed'}
//                       </dd>
//                     </div>
//                   </dl>
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 <div>
//                   <h4 className="font-medium mb-2">Account Status</h4>
//                   <div className="flex items-center gap-2">
//                     <span
//                       className={`px-2 py-1 rounded-full text-xs font-medium ${
//                         selectedVendor.verified
//                           ? 'bg-green-100 text-green-800'
//                           : 'bg-red-100 text-red-800'
//                       }`}
//                     >
//                       {selectedVendor.verified ? 'Verified' : 'Unverified'}
//                     </span>
//                     <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                       {selectedVendor.role}
//                     </span>
//                   </div>
//                 </div>
//                 <div>
//                   <h4 className="font-medium mb-2">Preferences</h4>
//                   <dl className="grid grid-cols-2 gap-2">
//                     <div>
//                       <dt className="text-sm text-gray-500">Interest In</dt>
//                       <dd className="text-sm">{selectedVendor.interest_in}</dd>
//                     </div>
//                     <div>
//                       <dt className="text-sm text-gray-500">Account Type</dt>
//                       <dd className="text-sm capitalize">{selectedVendor.plan}</dd>
//                     </div>
//                   </dl>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-4 pt-4 border-t border-gray-200">
//               <div className="flex justify-between text-sm text-gray-500">
//                 <div>
//                   Created: {new Date(selectedVendor.createdAt).toLocaleDateString()}
//                 </div>
//                 <div>
//                   Updated: {new Date(selectedVendor.updatedAt).toLocaleDateString()}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Vendor Table */}
//       <div className="bg-white rounded-lg shadow overflow-hidden">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Business Name
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Contact
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Plan
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {get_vendor_data?.users?.map((vendor) => (
//               <tr key={vendor._id} className={vendor.is_block ? "bg-red-50" : ""}>
//                 <td className="px-6 py-4 whitespace-nowrap">
//                   <div className="flex items-center">
//                     <div className="flex-shrink-0 h-10 w-10">
//                       <img
//                         className="h-10 w-10 rounded-full"
//                         src={vendor.avatar}
//                         alt={`${vendor.business_name} logo`}
//                       />
//                     </div>
//                     <div className="ml-4">
//                       <div className="text-sm font-medium text-gray-900">
//                         {vendor.business_name}
//                         {vendor.is_block && (
//                           <span className="ml-2 text-red-600 text-xs">
//                             (Blocked)
//                           </span>
//                         )}
//                       </div>
//                       <div className="text-sm text-gray-500">
//                         {vendor.first_name} {vendor.last_name}
//                       </div>
//                     </div>
//                   </div>
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   {vendor.email}
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                   <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
//                     {vendor.plan}
//                   </span>
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                   <button
//                     onClick={() => handleEdit(vendor)}
//                     className="text-yellow-600 hover:text-yellow-800 mr-4"
//                     aria-label="Edit vendor"
//                   >
//                     <FaEdit className="inline-block" />
//                   </button>
//                   <button
//                     onClick={() => handleView(vendor)}
//                     className="text-indigo-600 hover:text-indigo-900 mr-4"
//                     aria-label="View vendor"
//                   >
//                     <FaRegEye className="inline-block" />
//                   </button>
//                   <button
//                     onClick={() => handleBlock(vendor._id, vendor.is_block)}
//                     className={`${
//                       vendor.is_block
//                         ? "text-green-600 hover:text-green-800"
//                         : "text-red-600 hover:text-red-800"
//                     }`}
//                     aria-label={vendor.is_block ? "Unblock vendor" : "Block vendor"}
//                   >
//                     <FaBan className="inline-block" />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {get_vendor_status === asyncStatus.SUCCEEDED && !get_vendor_data?.users?.length && (
//           <div className="text-center py-4 text-gray-500">
//             No vendors found
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default VendorManagment;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  get_vendor,
  block_user,
  add_user,
  delete_user,
  update_user,
} from "../../store/services/authentication";
import {
  FaRegEye,
  FaTimes,
  FaBuilding,
  FaBan,
  FaCheckCircle,
  FaPlus,
  FaEdit,
  FaTrashAlt,
} from "react-icons/fa";
import { asyncStatus } from "../../utils/contants/asyncStatus";

const VendorManagment = () => {
  const dispatch = useDispatch();
  const {
    get_vendor_data,
    get_vendor_status,
    block_user_status,
    add_user_status,
    update_user_status,
    delete_user_status,
    add_user_error,
    update_user_error,
  } = useSelector((state) => state.userAuth);

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [formError, setFormError] = useState(null);
  const [formData, setFormData] = useState({
    business_name: "",
    email: "",
    plan: "basic",
    first_name: "",
    last_name: "",
    role: "Vendor",
  });

  useEffect(() => {
    dispatch(get_vendor());
  }, [
    dispatch,
    block_user_status,
    add_user_status,
    update_user_status,
    delete_user_status,
  ]);

  useEffect(() => {
    if (
      add_user_status === asyncStatus.SUCCEEDED ||
      update_user_status === asyncStatus.SUCCEEDED
    ) {
      setIsFormModalOpen(false);
      setFormError(null);
      setSelectedVendor(null);
      setIsEditMode(false);
    }
  }, [add_user_status, update_user_status]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddVendor = () => {
    setIsFormModalOpen(true);
    setIsEditMode(false);
    setFormData({
      business_name: "",
      email: "",
      plan: "basic",
      first_name: "",
      last_name: "",
      role: "Vendor",
    });
  };

  const handleEdit = (vendor) => {
    setSelectedVendor(vendor);
    setIsEditMode(true);
    setIsFormModalOpen(true);
    setFormData({
      business_name: vendor.business_name,
      email: vendor.email,
      plan: vendor.plan,
      first_name: vendor.first_name,
      last_name: vendor.last_name,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError(null);

    try {
      if (isEditMode) {
        await dispatch(
          update_user({
            id: selectedVendor._id,
            ...formData,
          })
        ).unwrap();
      } else {
        await dispatch(add_user(formData)).unwrap();
      }
    } catch (error) {
      setFormError(error.message || "An error occurred");
    }
  };

  const handleDelete = async (vendorId) => {
    if (window.confirm("Are you sure you want to delete this vendor?")) {
      try {
        await dispatch(delete_user(vendorId)).unwrap();
      } catch (error) {
        alert(`Delete failed: ${error.message}`);
      }
    }
  };

  const handleView = (vendor) => {
    setSelectedVendor(vendor);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVendor(null);
  };

  const handleBlock = (vendorId, isCurrentlyBlocked) => {
    const action = isCurrentlyBlocked ? "unblock" : "block";
    if (window.confirm(`Are you sure you want to ${action} this vendor?`)) {
      dispatch(
        block_user({
          id: vendorId,
          is_block: !isCurrentlyBlocked,
        })
      );
    }
  };

  if (get_vendor_status === asyncStatus.LOADING) {
    return (
      <div className="text-center py-8 text-black">Loading vendors...</div>
    );
  }

  if (get_vendor_status === asyncStatus.ERROR) {
    return (
      <div className="text-center py-8 text-red-500">Error loading vendors</div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Vendor Management</h1>
        <button
          onClick={handleAddVendor}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
        >
          <FaPlus className="inline-block" />
          Add Vendor
        </button>
      </div>

      {/* Add/Edit Vendor Modal */}
      {isFormModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-black">
                {isEditMode ? "Edit Vendor" : "Add New Vendor"}
              </h2>
              <button
                onClick={() => {
                  setIsFormModalOpen(false);
                  setFormError(null);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes className="h-6 w-6" />
              </button>
            </div>

            {(formError || add_user_error || update_user_error) && (
              <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg text-sm">
                {formError ||
                  add_user_error?.message ||
                  update_user_error?.message}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Business Name *
                  </label>
                  <input
                    type="text"
                    name="business_name"
                    value={formData.business_name}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border rounded-lg"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border rounded-lg"
                    required
                  />
                </div>
                {!isEditMode && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Password *
                    </label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border rounded-lg"
                      required
                    />
                  </div>
                )}

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      First Name *
                    </label>
                    <input
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border rounded-lg"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Last Name *
                    </label>
                    <input
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border rounded-lg"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Plan *
                  </label>
                  <select
                    name="plan"
                    value={formData.plan}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border rounded-lg"
                    required
                  >
                    <option value="basic">Basic</option>
                    <option value="pro">Pro</option>
                    <option value="enterprise">Enterprise</option>
                  </select>
                </div>

                <div className="mt-6">
                  <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
                  >
                    {isEditMode ? "Update Vendor" : "Add Vendor"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Vendor View Modal */}
      {isModalOpen && selectedVendor && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold flex items-center gap-2 text-black">
                <FaBuilding className="inline-block" />
                {selectedVendor.business_name}
                {selectedVendor.is_block && (
                  <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-sm">
                    Blocked
                  </span>
                )}
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes className="h-6 w-6" />
              </button>
            </div>

            {selectedVendor.is_block && (
              <div className="bg-red-50 p-4 rounded-lg mb-4">
                <div className="flex justify-between items-center">
                  <h3 className="font-medium text-red-800">Block Details</h3>
                  <button
                    onClick={() => handleBlock(selectedVendor._id, true)}
                    className="text-green-600 hover:text-green-800 flex items-center gap-1"
                  >
                    <FaCheckCircle className="inline-block" />
                    <span>Unblock Vendor</span>
                  </button>
                </div>
                {selectedVendor.block_reason && (
                  <p className="mt-2 text-red-700">
                    {selectedVendor.block_reason}
                  </p>
                )}
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-black">
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <img
                    className="h-24 w-24 rounded-full"
                    src={selectedVendor.avatar}
                    alt="Vendor logo"
                  />
                  <div>
                    <h3 className="text-lg font-semibold">
                      {selectedVendor.first_name} {selectedVendor.last_name}
                    </h3>
                    <p className="text-gray-600">{selectedVendor.email}</p>
                    <p className="text-sm text-gray-500">
                      Vendor ID: {selectedVendor._id}
                    </p>
                  </div>
                </div>

                <div>
                  <h4 className="font-medium mb-2 text-black">
                    Business Details
                  </h4>
                  <dl className="space-y-2">
                    <div>
                      <dt className="text-sm text-gray-500">Business Plan</dt>
                      <dd className="text-sm font-medium">
                        {selectedVendor.plan}
                      </dd>
                    </div>
                    <div>
                      <dt className="text-sm text-gray-500">
                        Stripe Customer ID
                      </dt>
                      <dd className="text-sm break-all">
                        {selectedVendor.stripe_customer_id || "N/A"}
                      </dd>
                    </div>
                    <div>
                      <dt className="text-sm text-gray-500">Subscription ID</dt>
                      <dd className="text-sm break-all">
                        {selectedVendor.subscription_id || "Not subscribed"}
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <h4 className="font-medium mb-2">Account Status</h4>
                  <div className="flex items-center gap-2">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        selectedVendor.verified
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      {selectedVendor.verified ? "Verified" : "Unverified"}
                    </span>
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {selectedVendor.role}
                    </span>
                  </div>
                </div>
                <div>
                  <h4 className="font-medium mb-2">Preferences</h4>
                  <dl className="grid grid-cols-2 gap-2">
                    <div>
                      <dt className="text-sm text-gray-500">Interest In</dt>
                      <dd className="text-sm">{selectedVendor.interest_in}</dd>
                    </div>
                    <div>
                      <dt className="text-sm text-gray-500">Account Type</dt>
                      <dd className="text-sm capitalize">
                        {selectedVendor.plan}
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-gray-200">
              <div className="flex justify-between text-sm text-gray-500">
                <div>
                  Created:{" "}
                  {new Date(selectedVendor.createdAt).toLocaleDateString()}
                </div>
                <div>
                  Updated:{" "}
                  {new Date(selectedVendor.updatedAt).toLocaleDateString()}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Vendor Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Business Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Contact
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Plan
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {get_vendor_data?.users?.map((vendor) => (
              <tr
                key={vendor._id}
                className={vendor.is_block ? "bg-red-50" : ""}
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-10 w-10">
                      <img
                        className="h-10 w-10 rounded-full"
                        src={vendor.avatar}
                        alt={`${vendor.business_name} logo`}
                      />
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900">
                        {vendor.business_name}
                        {vendor.is_block && (
                          <span className="ml-2 text-red-600 text-xs">
                            (Blocked)
                          </span>
                        )}
                      </div>
                      <div className="text-sm text-gray-500">
                        {vendor.first_name} {vendor.last_name}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {vendor.email}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                    {vendor.plan}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button
                    onClick={() => handleEdit(vendor)}
                    className="text-yellow-600 hover:text-yellow-800 mr-4"
                    aria-label="Edit vendor"
                  >
                    <FaEdit className="inline-block" />
                  </button>
                  <button
                    onClick={() => handleView(vendor)}
                    className="text-indigo-600 hover:text-indigo-900 mr-4"
                    aria-label="View vendor"
                  >
                    <FaRegEye className="inline-block" />
                  </button>
                  <button
                    onClick={() => handleDelete(vendor._id)}
                    className="text-red-600 hover:text-red-800 mr-4"
                    aria-label="Delete vendor"
                  >
                    <FaTrashAlt className="inline-block" />
                  </button>
                  <button
                    onClick={() => handleBlock(vendor._id, vendor.is_block)}
                    className={`${
                      vendor.is_block
                        ? "text-green-600 hover:text-green-800"
                        : "text-red-600 hover:text-red-800"
                    }`}
                    aria-label={
                      vendor.is_block ? "Unblock vendor" : "Block vendor"
                    }
                  >
                    <FaBan className="inline-block" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {get_vendor_status === asyncStatus.SUCCEEDED &&
          !get_vendor_data?.users?.length && (
            <div className="text-center py-4 text-gray-500">
              No vendors found
            </div>
          )}
      </div>
    </div>
  );
};

export default VendorManagment;
